module.exports = __webpack_public_path__ + "img/img21.0ca88a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img21.png
// module id = 262
// module chunks = 0